/** About 页顶部横幅 — 18 语言 */
export const aboutTranslations = {
  zh: {
    aboutHeroLine1: "23年专注数字打印设备研发制造",
    aboutHeroLine2: "服务172个国家和地区",
    aboutHeroLine3: "年设备交付能力 53,000+",
    aboutHeroLine4: "支持OEM / ODM定制服务",
    aboutHeroCtaSolution: "获取专属方案",
    aboutHeroCtaFactory: "预约参观工厂",
    aboutHeroStatClients: "215,000+",
    aboutHeroStatDelivered: "53,000+",
    aboutHeroStatCountries: "172+",
    aboutHeroStatYears: "23年",
    aboutHeroStatClientsLabel: "合作客户",
    aboutHeroStatDeliveredLabel: "年设备交付能力",
    aboutHeroStatCountriesLabel: "服务国家",
    aboutHeroStatYearsLabel: "行业经验",
    aboutHeroTagSgs: "SGS认证工厂",
    aboutHeroTagCe: "CE认证",
    aboutHeroTagFcc: "FCC认证",
    aboutHeroTagRohs: "ROHS认证",
    aboutHeroTagOem: "OEM/ODM",
    aboutHeroTagSupport: "24H技术支持",
    aboutHeroImageAlt: "咏远数字打印设备生产车间",
    aboutHeroFactoryBadgeTitle: "YONGYUAN FACTORY",
    aboutHeroFactoryBadgeCapacity: "53,000+ Units / Year",
    aboutHeroFactoryBadgeClients: "215,000+ Customers Served",
    aboutCompanyStatCountriesPrefix: "服务",
    aboutCompanyStatCountries: "172",
    aboutCompanyStatCountriesLabel: "个国家和地区",
    aboutCompanyRnd1Title: "研发实验室",
    aboutCompanyRnd1Subtitle: "Industrial R&D Center",
    aboutCompanyRnd1Alt: "咏远科技研发实验室",
    aboutCompanyRnd2Title: "工程测试",
    aboutCompanyRnd2Subtitle: "Quality Inspection Center",
    aboutCompanyRnd2Alt: "咏远科技工程测试中心",
    aboutCompanyBreadcrumb: "首页 / 关于咏远",
    aboutCompanyTitle: "公司简介",
    aboutCompanySubtitle: "专注数字打印设备研发、制造、销售与全球服务",
    aboutCompanyP1:
      "咏远科技成立于2003年，是一家专注数字打印解决方案的国家高新技术企业，集研发、制造、销售与服务于一体。",
    aboutCompanyP2:
      "公司位于深圳，在上海、安徽及越南设有分支机构，持续为全球客户提供专业、高效的数字打印设备及应用解决方案。",
    aboutCompanyP3:
      "经过23年的持续发展，咏远科技累计服务超过215,000家客户，业务覆盖全球172个国家和地区，年设备交付能力超过53,000台，支持OEM / ODM定制合作。",
    aboutCompanyP4:
      "咏远科技建立了独有的6S服务体系，覆盖售前咨询、方案推荐、安装指导、技术培训、售后工程支持及长期运营陪伴，持续为客户创造长期价值。",
    aboutCultureTitle: "企业文化",
    aboutCultureSubtitle:
      "以客户价值为核心，以技术创新为驱动，持续打造可靠产品与专业服务。",
    aboutCultureValue1Title: "客户第一",
    aboutCultureValue1Text:
      "以客户需求为出发点，持续提供适合客户业务发展的打印解决方案。",
    aboutCultureValue2Title: "创新驱动",
    aboutCultureValue2Text:
      "持续投入产品研发与工艺优化，提升设备稳定性、效率与应用范围。",
    aboutCultureValue3Title: "长期服务",
    aboutCultureValue3Text:
      "通过6S服务体系，为客户提供\n售前咨询、安装培训、售后支持与长期陪伴。",
    aboutCultureValue4Title: "结果导向",
    aboutCultureValue4Text:
      "坚持用结果检验服务价值，帮助客户实现更稳定的生产与商业增长。",
    aboutCultureImage1Alt: "咏远科技企业文化墙",
    aboutCultureImage1Caption: "企业文化墙",
    aboutCultureImage1Subtitle: "Corporate Culture Wall",
    aboutCultureImage2Alt: "咏远科技团队服务现场",
    aboutCultureImage2Caption: "团队服务现场",
    aboutCultureImage2Subtitle: "Team Service Site",
    aboutGlobalTitle: "全球客户网络",
    aboutGlobalStatCountriesValue: "172",
    aboutGlobalStatCountriesLabel: "服务国家与地区",
    aboutGlobalStatClientsValue: "215,000+",
    aboutGlobalStatClientsLabel: "合作客户",
    aboutGlobalStatCapacityValue: "53,000+",
    aboutGlobalStatCapacityLabel: "年设备交付能力",
    aboutGlobalRegionAmerica: "美洲",
    aboutGlobalRegionEurope: "欧洲",
    aboutGlobalRegionMiddleEast: "中东",
    aboutGlobalRegionAsiaPacific: "亚太",
    aboutGlobalRegionSouthAmerica: "南美",
    aboutGlobalRegionsAria: "全球服务区域",
    aboutHonorsTitle: "资质荣誉",
    aboutHonorsSubtitle: "持续通过多项质量与安全体系认证，夯实企业综合竞争力。",
    aboutHonorCe: "CE",
    aboutHonorCeAlt: "CE 认证证书",
    aboutHonorCeAlt2: "CE 符合性认证证书",
    aboutHonorSgs: "SGS",
    aboutHonorSgsAlt: "SGS 验厂认证报告",
    aboutHonorQir: "质检报告",
    aboutHonorQirAlt: "UV 打印机检测报告",
    aboutHonorFcc: "FCC",
    aboutHonorFccAlt: "FCC 符合性声明证书",
    aboutHonorStatPatentsValue: "20+",
    aboutHonorStatPatentsLabel: "项专利",
    aboutHonorStatCertificationsValue: "10+",
    aboutHonorStatCertificationsLabel: "项国际认证",
  },
  en: {
    aboutHeroLine1: "23 years in digital printing equipment R&D and manufacturing",
    aboutHeroLine2: "Serving 172 countries and regions",
    aboutHeroLine3: "53,000+ Annual Capacity",
    aboutHeroLine4: "OEM / ODM customization services supported",
    aboutHeroCtaSolution: "Get a Custom Solution",
    aboutHeroCtaFactory: "Book a Factory Visit",
    aboutHeroStatClients: "215,000+",
    aboutHeroStatDelivered: "53,000+",
    aboutHeroStatCountries: "172+",
    aboutHeroStatYears: "23 yrs",
    aboutHeroStatClientsLabel: "Customers",
    aboutHeroStatDeliveredLabel: "Annual Capacity",
    aboutHeroStatCountriesLabel: "Countries Served",
    aboutHeroStatYearsLabel: "Industry Experience",
    aboutHeroTagSgs: "SGS Certified Factory",
    aboutHeroTagCe: "CE Certified",
    aboutHeroTagFcc: "FCC Certified",
    aboutHeroTagRohs: "RoHS Certified",
    aboutHeroTagOem: "OEM/ODM",
    aboutHeroTagSupport: "24/7 Technical Support",
    aboutHeroImageAlt: "Yongyuan digital printing production workshop",
    aboutHeroFactoryBadgeTitle: "YONGYUAN FACTORY",
    aboutHeroFactoryBadgeCapacity: "53,000+ Units / Year",
    aboutHeroFactoryBadgeClients: "215,000+ Customers Served",
    aboutCompanyStatCountriesPrefix: "Serving ",
    aboutCompanyStatCountries: "172",
    aboutCompanyStatCountriesLabel: " countries and regions",
    aboutCompanyRnd1Title: "R&D Laboratory",
    aboutCompanyRnd1Subtitle: "Industrial R&D Center",
    aboutCompanyRnd1Alt: "Yongyuan R&D laboratory",
    aboutCompanyRnd2Title: "Engineering Testing",
    aboutCompanyRnd2Subtitle: "Quality Inspection Center",
    aboutCompanyRnd2Alt: "Yongyuan engineering test center",
    aboutCompanyBreadcrumb: "Home / About Yongyuan",
    aboutCompanyTitle: "Company Profile",
    aboutCompanySubtitle:
      "Focused on R&D, manufacturing, sales, and global service for digital printing equipment",
    aboutCompanyP1:
      "Founded in 2003, Yongyuan Technology is a national high-tech enterprise specializing in digital printing solutions, integrating R&D, manufacturing, sales, and service.",
    aboutCompanyP2:
      "Headquartered in Shenzhen, with branches in Shanghai, Anhui, and Vietnam, we deliver professional, efficient digital printing equipment and application solutions to customers worldwide.",
    aboutCompanyP3:
      "After 23 years of continuous growth, Yongyuan has served more than 215,000 customers across 172 countries and regions, with annual equipment delivery capacity exceeding 53,000 units, and supports OEM / ODM partnerships.",
    aboutCompanyP4:
      "Yongyuan’s proprietary 6S service system covers pre-sales consulting, solution recommendations, installation guidance, technical training, after-sales engineering support, and long-term operational partnership — creating lasting value for customers.",
    aboutCultureTitle: "Corporate Culture & Values",
    aboutCultureSubtitle:
      "Customer value at the core, innovation as the driver — building reliable products and professional services.",
    aboutCultureValue1Title: "Customer First",
    aboutCultureValue1Text:
      "We start from customer needs and deliver printing solutions tailored to each business.",
    aboutCultureValue2Title: "Innovation Driven",
    aboutCultureValue2Text:
      "Continuous R&D and process optimization to improve stability, efficiency, and application range.",
    aboutCultureValue3Title: "Long-term Service",
    aboutCultureValue3Text:
      "Our 6S service system covers\npre-sales consulting, installation training, after-sales support, and ongoing partnership.",
    aboutCultureValue4Title: "Results Oriented",
    aboutCultureValue4Text:
      "We measure service value by outcomes, helping customers achieve stable production and business growth.",
    aboutCultureImage1Alt: "Yongyuan corporate culture wall",
    aboutCultureImage1Caption: "Culture Wall",
    aboutCultureImage1Subtitle: "Corporate Culture Wall",
    aboutCultureImage2Alt: "Yongyuan team service site",
    aboutCultureImage2Caption: "Team Service",
    aboutCultureImage2Subtitle: "Team Service Site",
    aboutGlobalTitle: "Global Customer Network",
    aboutGlobalStatCountriesValue: "172",
    aboutGlobalStatCountriesLabel: "Countries Served",
    aboutGlobalStatClientsValue: "215,000+",
    aboutGlobalStatClientsLabel: "Customers",
    aboutGlobalStatCapacityValue: "53,000+",
    aboutGlobalStatCapacityLabel: "Annual Capacity",
    aboutGlobalRegionAmerica: "America",
    aboutGlobalRegionEurope: "Europe",
    aboutGlobalRegionMiddleEast: "Middle East",
    aboutGlobalRegionAsiaPacific: "Asia Pacific",
    aboutGlobalRegionSouthAmerica: "South America",
    aboutGlobalRegionsAria: "Global service regions",
    aboutHonorsTitle: "Certifications & Honors",
    aboutHonorsSubtitle:
      "Continuously certified across quality and safety systems, strengthening our competitive edge.",
    aboutHonorCe: "CE",
    aboutHonorCeAlt: "CE Certificate",
    aboutHonorCeAlt2: "CE Certificate of Conformity",
    aboutHonorSgs: "SGS",
    aboutHonorSgsAlt: "SGS Factory Audit Report",
    aboutHonorQir: "Testing Report",
    aboutHonorQirAlt: "UV Printer Testing Report",
    aboutHonorFcc: "FCC",
    aboutHonorFccAlt: "FCC Declaration of Conformity",
    aboutHonorStatPatentsValue: "20+",
    aboutHonorStatPatentsLabel: "Patents",
    aboutHonorStatCertificationsValue: "10+",
    aboutHonorStatCertificationsLabel: "International Certifications",
  },
};

const en = aboutTranslations.en;

[
  "de",
  "pt",
  "es",
  "fr",
  "it",
  "hi",
  "ru",
  "ko",
  "ja",
  "th",
  "tr",
  "vi",
  "nl",
  "id",
  "ar",
  "pl",
].forEach((code) => {
  aboutTranslations[code] = { ...en };
});

aboutTranslations.de = {
  ...en,
  aboutHeroLine1: "23 Jahre F&E und Fertigung digitaler Druckgeräte",
  aboutHeroLine2: "172 Länder und Regionen",
  aboutHeroLine3: "Jährliche Kapazität: 53.000+",
  aboutHeroLine4: "OEM / ODM-Anpassungsservice unterstützt",
  aboutHeroCtaSolution: "Individuelle Lösung anfragen",
  aboutHeroCtaFactory: "Werksbesichtigung buchen",
  aboutHeroStatYearsLabel: "Branchenerfahrung",
  aboutHeroImageAlt: "Yongyuan Produktionswerkstatt",
};

aboutTranslations.ja = {
  ...en,
  aboutHeroLine1: "23年間、デジタル印刷機器の研究開発・製造に専念",
  aboutHeroLine2: "172の国と地域にサービス",
  aboutHeroLine3: "年間設備納品能力 53,000台",
  aboutHeroLine4: "OEM / ODMカスタマイズサービス対応",
  aboutHeroCtaSolution: "専用ソリューションを取得",
  aboutHeroCtaFactory: "工場見学を予約",
  aboutHeroStatYears: "23年",
  aboutHeroStatClientsLabel: "協力顧客",
  aboutHeroStatDeliveredLabel: "年間設備納品能力",
  aboutHeroStatCountriesLabel: "サービス国",
  aboutHeroStatYearsLabel: "業界経験",
  aboutHeroImageAlt: "咏远デジタル印刷設備の生産現場",
};

aboutTranslations.ko = {
  ...en,
  aboutHeroLine1: "23년간 디지털 프린팅 장비 연구개발 및 제조에 집중",
  aboutHeroLine2: "172개 국가 및 지역 서비스",
  aboutHeroLine3: "연간 설비 납품 역량 53,000대",
  aboutHeroLine4: "OEM / ODM 맞춤 제작 서비스 지원",
  aboutHeroCtaSolution: "맞춤 솔루션 받기",
  aboutHeroCtaFactory: "공장 견학 예약",
  aboutHeroStatYears: "23년",
  aboutHeroStatClientsLabel: "협력 고객",
  aboutHeroStatDeliveredLabel: "연간 설비 납품 역량",
  aboutHeroStatCountriesLabel: "서비스 국가",
  aboutHeroStatYearsLabel: "업계 경험",
  aboutHeroImageAlt: "용위안 디지털 프린팅 생산 현장",
};

const COMPANY_LOCALES = {
  de: {
    aboutCompanyBreadcrumb: "Startseite / Über Yongyuan",
    aboutCompanyTitle: "Unternehmensprofil",
    aboutCompanySubtitle:
      "Fokus auf F&E, Fertigung, Vertrieb und globalen Service für digitale Druckgeräte",
  },
  ja: {
    aboutCompanyBreadcrumb: "ホーム / Yongyuanについて",
    aboutCompanyTitle: "会社概要",
    aboutCompanySubtitle: "デジタル印刷機器の研究開発・製造・販売・グローバルサービスに注力",
    aboutCompanyRnd1Alt: "咏远科技の研究開発ラボ",
    aboutCompanyRnd2Alt: "咏远科技のエンジニアリング試験センター",
  },
  ko: {
    aboutCompanyBreadcrumb: "홈 / Yongyuan 소개",
    aboutCompanyTitle: "회사 소개",
    aboutCompanySubtitle: "디지털 프린팅 장비 R&D·제조·판매·글로벌 서비스에 집중",
    aboutCompanyRnd1Alt: "용위안 연구개발 연구소",
    aboutCompanyRnd2Alt: "용위안 엔지니어링 테스트 센터",
  },
  es: {
    aboutCompanyBreadcrumb: "Inicio / Sobre Yongyuan",
    aboutCompanyTitle: "Perfil de la empresa",
    aboutCompanySubtitle:
      "Enfocados en I+D, fabricación, ventas y servicio global de equipos de impresión digital",
  },
  fr: {
    aboutCompanyBreadcrumb: "Accueil / À propos de Yongyuan",
    aboutCompanyTitle: "Profil de l’entreprise",
    aboutCompanySubtitle:
      "Axés sur la R&D, la fabrication, les ventes et le service mondial d’équipements d’impression numérique",
  },
  pt: {
    aboutCompanyBreadcrumb: "Início / Sobre a Yongyuan",
    aboutCompanyTitle: "Perfil da empresa",
    aboutCompanySubtitle:
      "Foco em P&D, fabricação, vendas e serviço global de equipamentos de impressão digital",
  },
  ru: {
    aboutCompanyBreadcrumb: "Главная / О Yongyuan",
    aboutCompanyTitle: "О компании",
    aboutCompanySubtitle:
      "Специализация на НИОКР, производстве, продажах и глобальном сервисе цифрового печатного оборудования",
  },
  vi: {
    aboutCompanyBreadcrumb: "Trang chủ / Về Yongyuan",
    aboutCompanyTitle: "Giới thiệu công ty",
    aboutCompanySubtitle:
      "Tập trung R&D, sản xuất, bán hàng và dịch vụ toàn cầu cho thiết bị in kỹ thuật số",
  },
  ar: {
    aboutCompanyBreadcrumb: "الرئيسية / عن Yongyuan",
    aboutCompanyTitle: "نبذة عن الشركة",
    aboutCompanySubtitle:
      "متخصصون في البحث والتطوير والتصنيع والمبيعات والخدمة العالمية لمعدات الطباعة الرقمية",
  },
};

for (const [code, overrides] of Object.entries(COMPANY_LOCALES)) {
  aboutTranslations[code] = {
    ...aboutTranslations[code],
    ...overrides,
  };
}
